import { useTranslation } from 'react-i18next';
import { CreateFormView } from '@/components/FormCreate/CreateForm';
import { Page } from '@/components/Ui/Page';
import { PageHeader } from '@/components/Ui/PageHeader';

export function CreateFormScreen() {
  const { t } = useTranslation();
  return (
    <Page width="narrow">
      <PageHeader
        title={t('create.pageTitle')}
        subtitle={t('create.subtitle')}
        breadcrumb={[{ label: t('forms.pageTitle'), to: '/account/forms' }]}
      />
      <CreateFormView />
    </Page>
  );
}
